import request from '@/request/index'

// 获取联系我们数据
export function getLinkUs(params) {
  return request.get('/anon/aboutus', params)
}

//发展历程：anon/companySummaries?type=1
// 荣誉资质：anon/companySummaries?type=2
export function getCompanySummaries(params) {
  return request.get('/anon/companySummaries', params)
}

//生产基地：/anon/branches
export function getBranches(params) {
  return request.get('/anon/branches', params)
}

//联系方式 anon/contacts?shortcut=1
export function getContacts(params) {
  return request.get('/anon/contacts', params)
}